
    export const Drinks = [
        {
          id:1,
          title: "tea",
          price: "30"
        },
        {
          id:2,
          title: "soda 500ml",
          price: "60"
        },
        {
          id:3,
          title: "soda 300ml",
          price: "40"
        },
        {
          id:4,
          title: "coffee",
          price: "40"
        },
        {
          id:5,
          title: "blended Fruit Juice",
          price: "50"
        },
        {
          id:6,
          title: "Minute Maid",
          price: "80"
        },
        {
          id:7,
          title: "Energy Drink",
          price: "60"
        },
        {
          id:8,
          title: "Dasani 500ml",
          price: "40"
        },
      ]
    
      export const Snacks = [
        {
          id: 1,
          title:"samosa",
          price:"30"
        },
        {
          id: 2,
          title:"chapati",
          price:"20"
        },
        {
          id: 3,
          title:"kebab",
          price:"40"
        },
        {
          id: 4,
          title:"fries - Medium",
          price:"70"
        },
        {
          id: 5,
          title:"fries - Large",
          price:"100"
        },
        {
          id: 6,
          title:"bhajia",
          price:"70"
        },
        {
          id: 7,
          title:"sausages",
          price:"40"
        },
        {
          id: 8,
          title:"smokies",
          price:"30"
        }
      ]
    
      export const Testimonials = [
        {
          id: 1,
          title: "George Collins",
          opinion: "Best services in town, I would 100% recommend",
          rating: "5.0",
        },
        {
          id: 2,
          title: "Collins Oloo",
          opinion: "I would recommend to my friends",
          rating: "4.1",
        },
        {
          id: 3,
          title: "Olosko George",
          opinion: "perfect services and nice ambience",
          rating: "4.8",
        },
        {
          id: 4,
          title: "George Oloo",
          opinion: "Quality food but pricy",
          rating: "3.2",
        },
        {
          id: 5,
          title: "Olosko Oloo",
          opinion: "Quality food and friendly service",
          rating: "4.3",
        },
      ]
      
      export const Courses = [
        {
          id: 1,
          title: "beans",
          price: "40"
        },
        {
          id: 2,
          title: "Mbuzi Fry",
          price: "200"
        },
        {
          id: 3,
          title: "Beef Fry",
          price: "200"
        },
        {
          id: 4,
          title: "Beef Stew",
          price: "200"
        },
        {
          id: 5,
          title: "Tilapia Dry Fry",
          price: "200"
        },
        {
          id: 6,
          title: "Tilapia Stew",
          price: "200"
        },
        {
          id: 7,
          title: "Matumbo Fry",
          price: "200"
        },
        {
          id: 8,
          title: "chicken",
          price: "200"
        },
      ]
